(function () {
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[＿_｜|/]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initCyberShell(root) {
    if (root.dataset.lostgShellReady === 'true') return;
    root.dataset.lostgShellReady = 'true';

    var drawer = root.querySelector('[data-lg-drawer]');
    var backdrop = root.querySelector('[data-lg-backdrop]');
    var open = root.querySelector('[data-lg-menu-open]');
    var close = root.querySelector('[data-lg-menu-close]');

    function setDrawer(shown) {
      if (!drawer || !backdrop || !open) return;
      drawer.classList.toggle('is-open', shown);
      backdrop.classList.toggle('is-open', shown);
      drawer.setAttribute('aria-hidden', shown ? 'false' : 'true');
      open.setAttribute('aria-expanded', shown ? 'true' : 'false');
      document.body.classList.toggle('lg-page-open', shown);
    }

    if (open) open.addEventListener('click', function () { setDrawer(true); });
    if (close) close.addEventListener('click', function () { setDrawer(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setDrawer(false); });
      });

      var startX = 0;
      drawer.addEventListener('touchstart', function (event) {
        startX = event.touches[0] ? event.touches[0].clientX : 0;
      }, { passive: true });
      drawer.addEventListener('touchend', function (event) {
        if (event.changedTouches[0] && event.changedTouches[0].clientX - startX < -55) setDrawer(false);
      }, { passive: true });
    }

    var tickers = Array.prototype.slice.call(root.querySelectorAll('[data-lg-ticker] a'));
    var tickerIndex = 0;
    if (tickers.length > 1) {
      window.setInterval(function () {
        tickers[tickerIndex].classList.remove('is-active');
        tickerIndex = (tickerIndex + 1) % tickers.length;
        tickers[tickerIndex].classList.add('is-active');
      }, 4200);
    }
  }

  function initProduct(root) {
    var variantScript = root.querySelector('[data-lostg-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    var thumbs = root.querySelector('[data-lostg-thumbs]');
    var mediaPanels = root.querySelectorAll('[data-lostg-media-panel]');
    var productForm = root.querySelector('.lostg-product__form');
    var hiddenVariant = root.querySelector('[data-lostg-variant-id]');
    var price = root.querySelector('[data-lostg-price]');
    var availability = root.querySelector('[data-lostg-availability]');
    var submit = root.querySelector('[data-lostg-submit]');
    var addCart = root.querySelector('[data-lostg-add-cart]');
    var quantityInput = root.querySelector('input[name="quantity"]');

    function hasHandleToken(text, token) {
      if (!text || !token) return false;
      return text.split('-').indexOf(token) !== -1;
    }

    function fetchCartCount() {
      if (window.LOSTGCartCount && typeof window.LOSTGCartCount.fetch === 'function') {
        return window.LOSTGCartCount.fetch();
      }

      var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      return fetch(cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-lg-cart-badge], [data-lg-cart-count]').forEach(function (badge) {
            var itemCount = Number(cart.item_count) || 0;
            badge.textContent = String(itemCount);
            badge.classList.toggle('is-hidden', itemCount <= 0);
          });
          return cart;
        });
    }

    function addCurrentVariantToCart(button, options) {
      if (!hiddenVariant || !hiddenVariant.value) return;
      var actionButton = button || addCart;
      var shouldRedirect = options && options.redirect;
      var redirectUrl = options && options.redirectUrl ? options.redirectUrl : '/cart';
      var originalText = actionButton ? actionButton.textContent : '';
      if (actionButton) {
        actionButton.disabled = true;
        actionButton.textContent = shouldRedirect ? '[ 購入手続き中... ]' : '[ 追加中... ]';
      }

      var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(hiddenVariant.value),
          quantity: Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1)
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart add failed');
          return response.json();
        })
        .then(fetchCartCount)
        .then(function () {
          if (shouldRedirect) {
            window.location.href = redirectUrl;
            return;
          }

          if (!actionButton) return;
          actionButton.textContent = '[ カートに追加済み ]';
          window.setTimeout(function () {
            actionButton.textContent = originalText;
            actionButton.disabled = false;
          }, 1200);
        })
        .catch(function () {
          if (!actionButton) return;
          actionButton.textContent = '[ 追加できませんでした ]';
          window.setTimeout(function () {
            actionButton.textContent = originalText;
            actionButton.disabled = false;
          }, 1600);
        });
    }

    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-option-position]').forEach(function (group) {
        var active = group.querySelector('.lostg-product__choice.is-active');
        values[Number(group.dataset.optionPosition) - 1] = active ? active.dataset.optionValue : '';
      });
      return values;
    }

    function findVariant() {
      var options = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function moveThumbRail(button) {
      if (!thumbs) return;
      var railRect = thumbs.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();
      var edgeZone = railRect.width * 0.24;
      var step = buttonRect.width + 8;

      if (buttonRect.right > railRect.right - edgeZone) {
        thumbs.scrollBy({ left: step, behavior: 'smooth' });
        return;
      }

      if (buttonRect.left < railRect.left + edgeZone) {
        thumbs.scrollBy({ left: -step, behavior: 'smooth' });
      }
    }

    function filterMedia(colorHandle, colorValue) {
      if (!thumbs) return;
      var normalizedHandle = normalizeText(colorHandle);
      var normalizedValue = normalizeText(colorValue);
      var shown = [];
      thumbs.querySelectorAll('[data-lostg-thumb]').forEach(function (thumb) {
        var thumbColor = thumb.dataset.color;
        var thumbAlt = normalizeText(thumb.dataset.altHandle || thumb.getAttribute('aria-label') || '');
        var visible = !normalizedHandle ||
          thumbColor === normalizedHandle ||
          hasHandleToken(thumbAlt, normalizedHandle) ||
          hasHandleToken(thumbAlt, normalizedValue);
        thumb.hidden = !visible;
        if (visible) shown.push(thumb);
      });

      if (!shown.length) {
        thumbs.querySelectorAll('[data-lostg-thumb]').forEach(function (thumb) {
          thumb.hidden = false;
          shown.push(thumb);
        });
      }

      var current = shown[0];
      if (current) {
        activateMedia(current, false);
        thumbs.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }

    function activateMedia(button, shouldMove) {
      if (!button) return;
      root.querySelectorAll('[data-lostg-thumb]').forEach(function (thumb) {
        var active = thumb === button;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (mediaPanels.length) {
        mediaPanels.forEach(function (panel) {
          var active = panel.dataset.lostgMediaPanel === button.dataset.mediaId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (!active) {
            panel.querySelectorAll('video').forEach(function (video) {
              if (!video.paused) video.pause();
            });
          }
        });
      }

      if (shouldMove) moveThumbRail(button);
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;

      if (hiddenVariant) hiddenVariant.value = variant.id;
      if (price) price.textContent = variant.price;
      if (availability) {
        availability.innerHTML = variant.available ? '販売中 <span>Available</span>' : '在庫切れ <span>Sold Out</span>';
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.querySelector('span').textContent = variant.available ? '[ \u8cfc\u5165\u3059\u308b ]' : '[ \u5728\u5eab\u5207\u308c ]';
      }
      if (addCart) {
        addCart.disabled = !variant.available;
        addCart.textContent = variant.available ? '[ カートに入れる ]' : '[ 在庫切れ ]';
      }
    }

    root.addEventListener('click', function (event) {
      var choice = event.target.closest('.lostg-product__choice');
      if (choice) {
        var group = choice.closest('[data-option-position]');
        group.querySelectorAll('.lostg-product__choice').forEach(function (button) {
          var active = button === choice;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateVariant();

        if (group.dataset.optionKind === 'color') {
          filterMedia(choice.dataset.optionHandle, choice.dataset.optionValue);
        }
        return;
      }

      var thumb = event.target.closest('[data-lostg-thumb]');
      if (thumb) {
        activateMedia(thumb, true);
        return;
      }

      var qty = event.target.closest('[data-lostg-qty]');
      if (qty && quantityInput) {
        quantityInput.value = String(Math.max(1, (Number(quantityInput.value) || 1) + Number(qty.dataset.lostgQty)));
        return;
      }

      var purchaseButton = event.target.closest('[data-lostg-submit]');
      if (purchaseButton) {
        addCurrentVariantToCart(purchaseButton, { redirect: true, redirectUrl: purchaseButton.dataset.lostgCartLink || '/cart' });
        return;
      }

      var addButton = event.target.closest('[data-lostg-add-cart]');
      if (addButton) {
        addCurrentVariantToCart(addButton);
        return;
      }

      var back = event.target.closest('[data-lostg-back]');
      if (back) {
        event.preventDefault();
        if (window.history.length > 1) window.history.back();
      }
    });

    var activeColor = root.querySelector('[data-option-kind="color"] .lostg-product__choice.is-active[data-option-handle]');
    if (activeColor) filterMedia(activeColor.dataset.optionHandle, activeColor.dataset.optionValue);
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    }
    updateVariant();
  }

  document.querySelectorAll('[data-lg-root]').forEach(initCyberShell);
  document.querySelectorAll('.lostg-product').forEach(initProduct);
})();
